module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":{"booking":"Booking","menu":"Menu"}},"zh-TW":{"header":{"booking":"馬上訂票","menu":"目錄"}}}')
  delete Component.options._Ctor
}
